module.exports = __webpack_public_path__ + "assets/webgl/stickers_basecolor.jpg.4882de7d.webp";